import { c as _c } from "react/compiler-runtime";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { GroupCardState } from "./GroupCard";
import GroupCardContent from "./GroupCardContent";
import GroupCardHeader from "./GroupCardHeader";
export default function GroupCardView(t0) {
  const $ = _c(13);
  const {
    group,
    haveActiveGroupVoteAll,
    setState,
    onEditClick,
    userPlaceholder,
    titlePlaceholder
  } = t0;
  let t1;
  if ($[0] !== group || $[1] !== onEditClick || $[2] !== userPlaceholder) {
    t1 = <GroupCardHeader group={group} onEditClick={onEditClick} userPlaceholder={userPlaceholder} />;
    $[0] = group;
    $[1] = onEditClick;
    $[2] = userPlaceholder;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-h-px tw-w-full tw-rounded-full tw-bg-white/10 tw-shadow-[0_1px_0_rgba(8,15,29,0.35)]" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== group || $[6] !== haveActiveGroupVoteAll || $[7] !== setState || $[8] !== titlePlaceholder) {
    t3 = <GroupCardContent group={group} haveActiveGroupVoteAll={haveActiveGroupVoteAll} setState={setState} titlePlaceholder={titlePlaceholder} />;
    $[5] = group;
    $[6] = haveActiveGroupVoteAll;
    $[7] = setState;
    $[8] = titlePlaceholder;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t3) {
    t4 = <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-y-4 tw-px-4 tw-py-4 sm:tw-px-5 sm:tw-py-5">{t1}{t2}{t3}</div>;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}